"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUser = void 0;
var _alloyProvider = require("@adsk/alloy-provider");
const useUser = () => {
  return (0, _alloyProvider.useUser)() || {};
};
exports.useUser = useUser;
//# sourceMappingURL=alloyHooks.js.map